import { ActionTree } from 'vuex';
import { RootState, UserState } from './../types';
import { Client, SignInArguments, SignInResponse, BoatControlUser } from '@/common/apis/AccountApi';
import ApiProvider from '@/common/apis/ApiProvider';
export const actions: ActionTree<UserState, RootState> = {
    async login({ dispatch, commit, rootState }, args: SignInArguments): Promise<any> {
        commit('userLoggingIn');
        try {
            const api = ApiProvider.getAccontApi();
            const loginResponse = await api.signIn(args);

            if (!loginResponse.user) {
                commit('userLoggedInFailed', 'Logged in failed');
            } else {
                commit('userLoggedIn', loginResponse);
            }
        } catch (e) {
            commit('userLoggedInFailed', e);
            throw e;
        }
    },
    async logOff({ dispatch, commit }): Promise<any> {
        commit('userLoggedOut');
    },
    async verifyTimestamp() {
        // (1566406936 - (Date.now().valueOf() / 1000))
    },
};
